import axios from "axios"

const TesoreriaService = {
  getDevolucionesById(id: $TSMigrationFixMe) {
    return axios.get(`/Devolucion/${id}`)
  },

  // VISTA PAGOS Y COBROS
  createPago(data: $TSMigrationFixMe) {
    return axios.post("/pago", data)
  },
  createPagoDeFactura(data: $TSMigrationFixMe) {
    return axios.post("/PagoDeFactura", data, {
      headers: {
        "content-type": "application/json",
      },
    })
  },
  createCobro(data: $TSMigrationFixMe) {
    return axios.post("/cobro", data)
  },
  createCobroDeFactura(data: $TSMigrationFixMe) {
    return axios.post("/CobroDeFactura", data, {
      headers: {
        "content-type": "application/json",
      },
    })
  },
  // VISTA CARTERA
  createPagoFactura(data: $TSMigrationFixMe) {
    return axios.post("/PagoDeFactura", data)
  },
  createCobroFactura(data: $TSMigrationFixMe) {
    return axios.post("/CobroDeFactura", data)
  },
  createDevolucion(data: $TSMigrationFixMe) {
    return axios.post("/Devolucion", data, {
      headers: {
        "content-type": "application/json",
      },
    })
  },
  editPago({ data, id }: $TSMigrationFixMe) {
    return axios.put(`/FlujoTesoreria/${id}`, data)
  },
  editCobro({ data, id }: $TSMigrationFixMe) {
    return axios.put(`/FlujoTesoreria/${id}`, data)
  },
  editPagoRemesable({ data, id }: $TSMigrationFixMe) {
    return axios.put(`/FlujoTesoreriaRemesable/${id}`, data)
  },
  editCobroRemesable({ data, id }: $TSMigrationFixMe) {
    return axios.put(`/FlujoTesoreriaRemesable/${id}`, data)
  },
  deleteRemesaFlujoTesoreria({ id, flujoTesoreriaId }: $TSMigrationFixMe) {
    return axios.delete(`/remesa/${id}/flujo-tesoreria/${flujoTesoreriaId}`)
  },
  deleteCobro(id: $TSMigrationFixMe) {
    return axios.delete(`/FlujoTesoreria/${id}`)
  },
  deletePago(id: $TSMigrationFixMe) {
    return axios.delete(`/FlujoTesoreria/${id}`)
  },
  deletePagosYCobros(data: $TSMigrationFixMe) {
    return axios.delete(`/FlujoTesoreria/bulk`, { data })
  },
  deleteRemesas(data: $TSMigrationFixMe) {
    return axios.delete(`/remesa/bulk`, { data })
  },
  deleteDevolucion(id: $TSMigrationFixMe) {
    return axios.delete(`/Devolucion/${id}`)
  },
  editDevolucion({ data, id }: $TSMigrationFixMe) {
    return axios.put(`/Devolucion/${id}`, data, {
      headers: {
        "content-type": "application/json",
      },
    })
  },
  // generico
  createSimpleRemesa(data: $TSMigrationFixMe) {
    return axios.post("/Remesa", data)
  },
  deleteRemesa(id: $TSMigrationFixMe) {
    return axios.delete(`/remesa/${id}`)
  },
  downloadRemesaSinRelacionFile(id: $TSMigrationFixMe) {
    return axios.get(`Remesa/${id}/sepa-xml`)
  },
  createRemesaDevolucion(data: $TSMigrationFixMe) {
    return axios.post("/RemesaDeDevolucion", data)
  },
  donwloadRemesaDevolucionFile(id: $TSMigrationFixMe) {
    return axios.get(`RemesaDeDevolucion/${id}/sepa-xml`)
  },
  donwloadRemesaTicketFile(id: $TSMigrationFixMe) {
    return axios.get(`RemesaDeTicket/${id}/sepa-xml`)
  },
  createRemesaPrestamo(data: $TSMigrationFixMe) {
    return axios.post("/RemesaDePrestamo", data)
  },
  donwloadRemesaPrestamoFile(id: $TSMigrationFixMe) {
    return axios.get(`RemesaDePrestamo/${id}/sepa-xml`)
  },
  donwloadRemesaFile(id: $TSMigrationFixMe) {
    return axios.get(`RemesaDeFactura/${id}/sepa-xml`)
  },
}

export default TesoreriaService
